/// <reference path="../../../typings/browser.d.ts" />

namespace Application.Controllers {
    'use strict';

    import ValidationUtils = Application.Common.ValidationUtils;
    import Utils = Common.Utils;

    export interface IGatewayModalScope extends ng.IScope {
        gateway: Models.Gateway;
        isNewGateway: boolean;
        modalClose: () => void;
        modalSave: () => void;
    }

    /**
     * GatewayModalController class
     */
    export class GatewayModalController {
        public static templateUrl: string = "decorators/modals/gateway-modal.html";
        public static ID: string = "#id-gateway-modal";
        public static $name: string = "gatewayModalController";
        public static $inject: string[] = ['$scope', '$q', 'close', '$timeout', 'gateway', 'gatewayService'];

        private $scope: IGatewayModalScope;
        private close: (parameters: ngModal.ICloseParameters) => void;
        private static PARSLEY_VALIDATE_GATEWAY_NAME: string = "validateGatewayName";
        private originalName: string = undefined;

        /**
         * Constructor
         */
        constructor($scope: IGatewayModalScope,
                    private $q: ng.IQService,
                    close: (parameters: ngModal.ICloseParameters) => void,
                    $timeout: ng.ITimeoutService,
                    gateway: Models.Gateway,
                    private gatewayService: Services.GatewayService) {
            $timeout(() => {
                window.altair_admin_common_init();
                window.altair_forms_validation();
            }, 500);

            this.$scope = $scope;
            this.$scope.isNewGateway = (gateway === undefined || gateway.name === "");
            this.close = close;

            this.addParsleyValidateGatewayName();

            if (this.$scope.isNewGateway)
                this.$scope.gateway = Models.Gateway.Empty();
            else {
                this.$scope.gateway = gateway;
                this.originalName = gateway.name;
            }

            this.$scope.modalClose = (): void => {
                this.close(undefined);
            };

            this.$scope.modalSave = async (): Promise<void> => {
                if (await this.isValidName()) {
                    this.close(this.$scope.gateway);
                }
            };
        }

        private addParsleyValidateGatewayName(): void {
            window.Parsley
                .addValidator(GatewayModalController.PARSLEY_VALIDATE_GATEWAY_NAME, {
                    validateString: (name: string): boolean => {
                        this.checkUsedName(name).then(usedName =>
                        {
                            ValidationUtils.toggleParsleyWarningClasses('gateway-name', usedName, "Name");
                        });
                        return true;
                    },
                    messages: {
                        en: name + ` already in use.`,
                    },
                });
        }

        private async isValidName(): Promise<boolean> {
            const notEmpty = this.$scope.gateway.name != undefined && this.$scope.gateway.name !== '';
            const isUsed = await this.checkUsedName(this.$scope.gateway.name);
            return notEmpty && !isUsed;
        }

        private checkUsedName(name: string): ng.IPromise<boolean> {
            if (this.originalName && name && this.originalName === name) {
                return Utils.getBoolPromise(this.$q, false);
            }
            return this.gatewayService.checkUsedNamePromise(name);
        }
    }
}
